import React from "react";
import IMG1 from "../../assets/scrollanimations.png";
import IMG2 from "../../assets/BookHive.png";
import IMG3 from "../../assets/groupquest.png";
import IMG4 from "../../assets/store-ecom.png";
import IMG5 from "../../assets/linkedin-platform.png";
import IMG6 from "../../assets/Boost-ai.png";

import "./portfolio.css";

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "Interactive Web Experiences Project",
      img: IMG1,
      description:
        "Utilized GSAP (GreenSock Animation Platform)  ScrollTriggerScrollMagic and tweenMax to create dynamic onScroll effects and captivating animations for an interactive web experience.",
      technologies: "GSAP | SCROLLTRIGGER | SCROLLMAGIC",
      link: "https://scroll-animations-gsap.netlify.app/",
      github: "https://github.com/rashidpbi/ScrollAnimation",
    },
    {
      id: 2,
      title: "LinkedIn Platform ",
      img: IMG5,
      description:
        "A modern, full-stack social networking platform built with Next.js, React, Firebase, MongoDB, and Express.js.This application provides essential LinkedIn-like features including user authentication, profile management, and a social feed for sharing posts.",
      technologies: "React | Nextjs | Mern | Firebase",
      link: "https://mini-linkedin-platform.vercel.app/",
      github: "https://github.com/rashidpbi/linkedin-platform",
    },

    {
      id: 3,
      title: "GroupQuest",
      img: IMG3,
      description:
        "A front-end website project built with HTML, CSS, and JavaScript, designed to provide users with a platform to explore and connect with diverse interest groups.",
      technologies: "HTML | CSS | JavaScript",
      link: "https://site-landing-page-task1.netlify.app/",
      github: "https://github.com/rashidpbi/GroupQuest",
    },
    {
      id: 4,
      title: "Store ecommerce Website",
      img: IMG4,
      description:
        "Ecommerce built using React, Next.js with App Router, TypeScript, GraphQL, and Tailwind CSS.",
      technologies: "Reactjs | Nextjs | TypeScript | GraphQL | Tailwind",
      link: "https://storefront.saleor.io/",
      github: "https://github.com/rashidpbi/store-ecom",
    },
    // {
    //   id: 5,
    //   title: 'Drumkit Project',
    //   img: IMG5,
    //   description: "The drum kit app is a dynamic web application designed to simulate a drum kit using HTML, CSS, and JavaScript.",
    //   technologies: 'HTML | CSS | JavaScript',
    //   link: 'https://drum-kit-proj.netlify.app/',
    //   github: 'https://github.com/rashidpbi/drum-kit',
    // },
    {
      id: 5,
      title: "Book Hive",
      img: IMG2,
      description:
        "BookHive is a comprehensive full-stack web application that transforms how book enthusiasts connect, share, and discover literature",
      technologies: "React | Typescript | Tailwind ",
      link: "https://book-hive-frontend.onrender.com/",
      github: "https://github.com/rashidpbi/BookHive",
    },

    {
      id: 6,
      title: "Boost-Ai ",
      img: IMG6,
      description:
        "Boost AI is a smart chat assistant with user authentication, image upload via ImageKit, markdown support, and per-user chat history. Built using React, Node.js, and MongoDB, it offers a seamless and responsive UI with secure backend APIs powered by Clerk and rich media rendering for dynamic conversations.",
      technologies:
        "React.js | Vite | React Router | React Tanstack | Node.js | Express.js | Clerk Authentication",
      link: "https://boost-ai-chat.vercel.app/",
      github: "https://github.com/rashidpbi/Boost-Ai",
    },
  ];

  return (
    <section id="portfolio">
      {/* <h5>Side Projects & Experiments</h5> */}
      <h7>My recent technical explorations beyond my day-to-day work</h7>
      <h2>Projects</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Visit Website
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
